module.exports = __webpack_public_path__ + "img/icon-tasks.ad9f214e.svg";